<div class="walking">
  <div class="park"></div>
  <div class="trees"></div>
  <div class="paw" [style.background-image]="statesService.backgroundImageSrc + statesService.imageNumber + '.webp)'"></div>
</div>
